<div [class.isSimply]='this.isSimply()'>
<app-header></app-header>
<app-breadcrumb></app-breadcrumb>
<app-sidebar></app-sidebar>
<router-outlet></router-outlet>
<app-assistant-launcher></app-assistant-launcher>
<app-toast></app-toast>
</div>
